'use strict';

angular.module('app.rankingScoreReportTopic', [])
    .directive('rankingScoreReportTopicDirective', function () {
        return {
            controller: 'rankingScoreReportTopicCtrl',
            templateUrl: 'app/measure/rankingScoreReport/rankingScoreReportTopic/rankingScoreReportTopic.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })